import React from "react";
export default function Footer() {
   return (
      <footer className="bg-gray-900 text-white py-8">
         <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row justify-between items-center">
               {/* Copyright */}
               <div className="mb-4 md:mb-0">
                  <p className="text-center md:text-left text-sm">
                     &copy; {new Date().getFullYear()} Darius Amenda. All rights reserved.
                  </p>
               </div>

               {/* Social Media Links */}
               <div className="flex space-x-4 mb-4 md:mb-0">
                  <a href="https://www.facebook.com/dariusamenda" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500 transition-colors duration-300">
                     <i className="fab fa-facebook-f"></i> Facebook
                  </a>
                  <a href="https://www.instagram.com/dariusamenda" target="_blank" rel="noopener noreferrer" className="hover:text-pink-500 transition-colors duration-300">
                     <i className="fab fa-instagram"></i> Instagram
                  </a>
                  <a href="https://twitter.com/dariusamenda" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors duration-300">
                     <i className="fab fa-twitter"></i> Twitter
                  </a>
                  <a href="https://www.youtube.com/dariusamenda" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors duration-300">
                     <i className="fab fa-youtube"></i> YouTube
                  </a>
               </div>

               {/* Navigation Links */}
               <div className="flex space-x-4">
                  <a href="#portfolio" className="hover:text-gray-400 transition-colors duration-300">Portfolio</a>
                  <a href="#about" className="hover:text-gray-400 transition-colors duration-300">About</a>
                  <a href="#contact" className="hover:text-gray-400 transition-colors duration-300">Contact</a>
               </div>
            </div>
         </div>
      </footer>
   );
}
